<template>

    <v-section name="Text" :expanded="expanded">
        <v-action-align />
        <v-action-font-family />
        <v-action-size type="font-size" :min="1" :max="100" />
        <v-action-size type="letter-spacing" :min="0" :max="100" />
        <v-action-size type="line-height" :min="0" :max="100" />
    </v-section>

</template>

<script>

import ActionAlign from './../actions/ActionAlign';
import ActionFontFamily from './../actions/ActionFontFamily';
import ActionSize from './../actions/ActionSize';
import Section from './Section';

export default {

    components: {
        'v-action-align': ActionAlign,
        'v-action-font-family': ActionFontFamily,
        'v-action-size': ActionSize,
        'v-section': Section,
    },

    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
    },

}

</script>